interface CodeGroupsResultPossible {
  possibleCode: true
  groups: CodeMatch
}

interface CodeGroupsResultImpossible {
  possibleCode: false
  groups: undefined
}

export type CodeGroupsResult = CodeGroupsResultPossible | CodeGroupsResultImpossible

export interface CodeMatch {
  code: string
  variant: string
}

export function isPossibleCodeMatch(result: CodeGroupsResult | undefined): result is CodeGroupsResultPossible {
  return result?.possibleCode === true
}

export const matchCodeGroups = (search: string): CodeGroupsResult => {
  const matcher = /^(?<code>[0-9]+)(?<variant>[a-zA-Z-]+)/
  const result = search.match(matcher)?.groups as CodeMatch | undefined

  if (result) {
    return {
      possibleCode: true,
      groups: result,
    }
  }

  return {
    possibleCode: false,
    groups: undefined,
  }
}
